/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupJob } from '../models/BackupJob';

export class GetBackupJobResponse {
  'job': BackupJob;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "job",
      "baseName": "job",
      "type": "BackupJob",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetBackupJobResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

